import { render, staticRenderFns } from "./OFilePreview.vue?vue&type=template&id=07a87c96&scoped=true&"
import script from "./OFilePreview.vue?vue&type=script&lang=js&"
export * from "./OFilePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a87c96",
  null
  
)

export default component.exports